var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar"},[_c('div',{staticClass:"picture"},[(_vm.picture)?_c('img',{style:({ width: _vm.pictureSize || '2rem', height: _vm.pictureSize || '2rem' }),attrs:{"src":_vm.picture,"alt":"user pic"}}):_c('i',{staticClass:"icon icon_profile",style:({ width: _vm.pictureSize || '2rem', height: _vm.pictureSize || '2rem' })})]),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ee58e5a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/avatar.vue
// module id = 1494
// module chunks = 0